module.exports = __webpack_public_path__ + "static/bitrix24-7695dac8fa41e6c487a81bef22ccac40.svg";